var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".account_svg__c{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.007 10.667a4 4 0 114-4 4 4 0 01-4 4zm0-6.666a2.667 2.667 0 102.666 2.666A2.667 2.667 0 0010.007 4z",
    fill: "#a1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    className: "account_svg__c",
    d: "M10.007 19.999a10 10 0 01-7.726-3.66l-.347-.427.347-.42a10 10 0 0115.453 0l.347.42-.347.427a10 10 0 01-7.727 3.66zm-6.326-4.08a8.666 8.666 0 0012.666 0 8.666 8.666 0 00-12.666 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "account_svg__c",
    d: "M10.011 20.001a10 10 0 117.726-3.66 10 10 0 01-7.726 3.66zm0-18.667a8.666 8.666 0 108.662 8.667 8.666 8.666 0 00-8.662-8.667z"
  }))));
}
export default SvgAccount;